// 使用时注意 PREFIX 不带 /
// VITE_PREFIX = https://flowus.cn
// VITE_CDN_HOST = https://cdn.flowus.cn/

export const {
  VITE_STRIPE_PUBLIC_KEY,
  VITE_SUBSCRIBE_ID,
  VITE_NOTION_CLIENT_ID,
  VITE_NO_SMS_SERVICE,
  VITE_NO_EMAIL_SERVICE,
} = import.meta.env;

export const VITE_PREFIX = window.VITE_PREFIX ?? import.meta.env.VITE_PREFIX ?? 'https://flowus.cn';
export const VITE_CDN_HOST = window.VITE_CDN_HOST ?? import.meta.env.VITE_CDN_HOST;
export const VITE_OSS_CDN_HOST = window.VITE_OSS_CDN_HOST ?? import.meta.env.VITE_OSS_CDN_HOST;

export const PROXY_TARGET = __PROXY_TARGET__;

export const isBuildIn = () => {
  try {
    return __BUILD_IN__;
  } catch {
    return import.meta.env.VITE_PRODUCT === 'buildin';
  }
};
